import { updateDefaultCity } from "../api/updateDefaultCity";

export const handleDateChange = (event, setStartDateSecond) => {
  const selectedDate = event.target.value;
  setStartDateSecond(selectedDate);
};

export const handleDefaultCityChange = (
  setDefaultSelectedCity,
  value,
  label
) => {
  setDefaultSelectedCity({ value, label });
};

export const handleRoomChange = (selectedOptions, setSelectedRooms) => {
  const selectedValues = selectedOptions.map((item) => item.value);
  setSelectedRooms(selectedValues);
};

export const handleCityChange = (
  selectedOptions,
  setSelectedCity,
  setZakupiteljType,
  userData,
  zakupitelj,
  setSelectedRooms
) => {
  setSelectedCity(selectedOptions);
  setZakupiteljType(
    userData.isZakupitelj || userData.roleId === 1
      ? zakupitelj?.cities?.find(
          (city) => city?.cityId === selectedOptions?.value
        )?.zakupiteljType || null
      : null
  );
  setSelectedRooms([]);
};

export const handleSubmitDefaultCity = async (
  defaultSelectedCity,
  authToken,
  setShowDefaultCityRadios,
  setUserData
) => {
  await updateDefaultCity(defaultSelectedCity.value, authToken);
  setShowDefaultCityRadios(false);
  setUserData((prevState) => ({
    ...prevState,
    defaultCity: defaultSelectedCity.value,
  }));
};

export const handleDateClick = (
  info,
  setType,
  setSelectedDate,
  setSecondSelectedRoomId,
  setIsCreateOpen
) => {
  const dateStr = info?.dateStr;
  const date = dateStr ? dateStr.split("T")[0] : null;
  const secondRoomId = info?.resource?.id;

  if (!date) {
    console.warn("Date string is undefined in handleDateClick:", info);
    return;
  }
  setType("create");
  setSelectedDate(date);
  setSecondSelectedRoomId(secondRoomId);
  setIsCreateOpen(true);
};

export const handleEventClick = ({
  info,
  role,
  zakupiteljType,
  userData,
  setType,
  setInfo,
  setIsInfoOpen,
  setEditEventValues,
  setIsCreateOpen,
}) => {
  const dateStart = new Date(info.event._instance.range.start);
  const dateEnd = new Date(info.event._instance.range.end);

  dateStart.setHours(dateStart.getHours() - 1);
  dateEnd.setHours(dateEnd.getHours() - 1);

  const hoursStart = dateStart.getHours();
  const minutesStart = dateStart.getMinutes();
  const secondsStart = dateStart.getSeconds();

  const hoursEnd = dateEnd.getHours();
  const minutesEnd = dateEnd.getMinutes();
  const secondsEnd = dateEnd.getSeconds();

  const formattedTimeStart = `${hoursStart
    .toString()
    .padStart(2, "0")}:${minutesStart
    .toString()
    .padStart(2, "0")}:${secondsStart.toString().padStart(2, "0")}`;

  const formattedTimeEnd = `${hoursEnd
    .toString()
    .padStart(2, "0")}:${minutesEnd.toString().padStart(2, "0")}:${secondsEnd
    .toString()
    .padStart(2, "0")}`;

  const secondInfo = {
    start: formattedTimeStart,
    end: formattedTimeEnd,
    roomId: info.event._def?.resourceIds
      ? info.event._def.resourceIds[0]
      : null,
    title: info.event._def.title,
    dateStart,
  };

  const clickedEvent = info.event._def.extendedProps;
  const isEditable = clickedEvent.isEditable;
  const eventStart = info.event.start;
  if (
    role === "Referada" ||
    (zakupiteljType !== null &&
      (userData.id === clickedEvent.therapistId ||
        userData.id === clickedEvent.creatorId ||
        userData.id === clickedEvent.supervisorId))
  ) {
    setType("edit");

    if (!isEditable) {
      if (secondInfo.roomId === null) {
        setInfo({
          room: clickedEvent.roomId,
          timeFrom: clickedEvent.timeFrom,
          timeTo: clickedEvent.timeTo,
          eventType: clickedEvent.eventType,
          therapistName: clickedEvent.therapistName || null,
          dateStart: secondInfo.dateStart || null,
        });
      } else {
        setInfo({
          room: parseInt(secondInfo.roomId, 10),
          timeFrom: secondInfo.start.slice(0, 5),
          timeTo: secondInfo.end.slice(0, 5),
          eventType: clickedEvent.eventType,
          title: secondInfo.title,
          therapistName: clickedEvent.therapistName || null,
          dateStart: secondInfo.dateStart || null,
        });
      }
      setIsInfoOpen(true);
    } else {
      if (
        clickedEvent.eventType === "therapy" ||
        clickedEvent.eventType === "individual_supervision" ||
        clickedEvent.eventType === "other"
      ) {
        setEditEventValues({
          eventId: info.event.id ? info.event.id : "",
          eventType: clickedEvent.eventType ? clickedEvent.eventType : "",
          supervisionType: "individual",
          clientId: clickedEvent.clientId ? clickedEvent.clientId : "",
          outsideClient: clickedEvent.clientOutsideIPD
            ? clickedEvent.clientOutsideIPD
            : "",
          name: secondInfo?.title,
          date: eventStart ? eventStart.toISOString().split("T")[0] : "",
          timeFrom: clickedEvent.timeFrom
            ? clickedEvent.timeFrom.slice(0, -3)
            : "",
          timeTo: clickedEvent.timeTo ? clickedEvent.timeTo.slice(0, -3) : "",
          description: clickedEvent.description ? clickedEvent.description : "",
          roomId: clickedEvent.roomId ? clickedEvent.roomId : "",
          therapistId: clickedEvent.therapistId ? clickedEvent.therapistId : "",
          creatorId: clickedEvent.creatorId ? clickedEvent.creatorId : "",
          supervisorId: clickedEvent.supervisorId
            ? clickedEvent.supervisorId
            : "",
        });
        setIsCreateOpen(true);
      } else {
        setInfo({
          room: clickedEvent.roomId ? clickedEvent.roomId : "",
          timeFrom: secondInfo.start?.slice(0, 5),
          timeTo: secondInfo.end?.slice(0, 5),
          eventType: clickedEvent.eventType,
          title: secondInfo?.title,
          therapistName: clickedEvent.therapistName || null,
          dateStart: secondInfo.dateStart || null,
        });
        setIsInfoOpen(true);
      }
    }
  } else {
    const data = {
      therapistName: clickedEvent.therapistName || null,
      room: parseInt(clickedEvent?.roomId, 10)
        ? parseInt(clickedEvent?.roomId, 10)
        : parseInt(secondInfo?.roomId, 10),
      timeFrom: secondInfo.start.slice(0, 5),
      timeTo: secondInfo.end.slice(0, 5),
      eventType: clickedEvent.eventType,
      title: secondInfo.title,
      clientId: clickedEvent.clientId ? clickedEvent.clientId : "",
      outsideClient: clickedEvent.clientName ? clickedEvent.clientName : "",
      therapistId: clickedEvent.therapistId ? clickedEvent.therapistId : "",
      dateStart: secondInfo.dateStart || null,
    };
    setInfo(data);
    setIsInfoOpen(true);
  }
};

export const handleInputChange = (
  name,
  value,
  setFormValues,
  setSelectedRoomId,
  setSelectedTimeStartLive,
  setSelectedTimeEndLive
) => {
  if (name === "roomId") {
    setSelectedRoomId(value);
    setSelectedTimeStartLive("0");
    setSelectedTimeEndLive({ label: "Odaberi" });
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
      timeFrom: "",
      timeTo: "",
    }));
  } else {
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  }
};

export const handleKlijentChange = (
  event,
  setSearchValue,
  setIsSearchVisible
) => {
  const { value } = event.target;
  setSearchValue(value);
  setIsSearchVisible(true);
};

export const handleKlijentClick = (
  value,
  name,
  surname,
  setSearchValue,
  setFormValues,
  setIsSearchVisible
) => {
  setSearchValue(name + " " + surname);
  setFormValues((prevValues) => ({
    ...prevValues,
    clientId: value,
  }));
  setIsSearchVisible(false);
};

export const handleStartTimeChange = (
  event,
  setSelectedTimeStart,
  setFormValues
) => {
  const selectedValue = event.target.value;
  setSelectedTimeStart(selectedValue);
  setFormValues((preValues) => ({
    ...preValues,
    timeFrom: selectedValue,
  }));
};

export const handleEndTimeChange = (
  event,
  setSelectedTimeEnd,
  setFormValues
) => {
  const selectedValue = event.target.value;
  setSelectedTimeEnd(selectedValue);
  setFormValues((preValues) => ({
    ...preValues,
    timeTo: selectedValue,
  }));
};
